import React from 'react'

import useCurrentUser from '@hooks/useCurrentUser'
import { getCampaignPermissionPath } from '@functions/campaign'

type CampaignType = 'agency_marketing' | 'property_marketing' | 'notifications'
interface EnabledPermissionProps {
  children: React.ReactElement,
  permissionKey: string,
  permissionRoleKey?: 'admin' | 'agency' | 'brand',
  campaignType?: CampaignType | undefined,
}

const EnabledPermission = (props: EnabledPermissionProps) => {
  const {
    children, permissionKey, permissionRoleKey = 'agency', campaignType,
  } = props

  const { currentUser, permissions } = useCurrentUser({
    performHttpRequests: false,
  })

  const rolePermissions = permissions[permissionRoleKey]
  if (!currentUser.id || !rolePermissions){
    return null
  }

  // Determine the permission context and path
  let permissionValue: boolean = false

  // Check if this is an admin permission (no campaign type needed)
  if (permissionKey.startsWith('admin.')){
    const [, permissionGroupKey, permissionKeyName] = permissionKey.split('.')
    const permissionPath = currentUser.custom_permissions?.agency?.admin?.[permissionGroupKey]?.[permissionKeyName]

    permissionValue = permissionPath !== undefined ? permissionPath : true
  } else if (permissionKey.startsWith('campaign.')){
    const [, permissionGroupKey, permissionKeyName] = permissionKey.split('.')

    permissionValue = getCampaignPermissionPath(currentUser, permissionGroupKey, permissionKeyName, campaignType)
  } else {
    // Legacy support: handle old format without campaign type
    const split = permissionKey.split('.')
    permissionValue = split.reduce((obj, key) => (obj?.[key] !== undefined ? obj[key] : false), rolePermissions)
  }

  if (!permissionValue) return null

  return children
}

export default EnabledPermission
